//Reference: EN005


import { Mappeable } from './mappeable.model';
import * as _ from 'lodash';

export class Country extends Mappeable {
    idCountryPk: number;
    cdIso: string;
    region: any;
    currency: any;
    txtName: string;
    mrkActive: boolean;

    constructor(o) {
        super(o);
        this.mrkActive = this.mrkActive ??  false 

    }

    public mapToBack() {
        return {
            cdIso: this.cdIso,
            region: this.region,
            currency: this.currency,
            txtName: this.txtName,
            mrkActive: this.mrkActive
        }
    }


}
